import axiosInstance from "../axiosInstance"
import type {
  MotoGearCategoryResponseDto,
  CreateMotoGearCategoryDto,
  UpdateMotoGearCategoryDto,
  MotoGearCategoryListParams,
  MotoGearCategoryListResponseDto,
  DeleteMotoGearCategoryResponseDto,
} from "../types/motoGearCategory.types"

/**
 * Moto Gear Category API Client
 * Direct API calls using axios instance
 */
export const motoGearCategoryClient = {
  // Get moto gear category by ID
  getMotoGearCategoryById: (id: string): Promise<MotoGearCategoryResponseDto> => {
    return axiosInstance.get(`/moto-gear-categories/${id}`)
  },

  // List moto gear categories with filters
  getMotoGearCategories: (params?: MotoGearCategoryListParams): Promise<MotoGearCategoryListResponseDto> => {
    const apiParams: Record<string, string | number> = {}

    if (params) {
      if (params.page !== undefined) {
        apiParams.page = params.page
      }
      if (params.limit !== undefined) {
        apiParams.limit = params.limit
      }
      if (params.search !== undefined && params.search !== "") {
        apiParams.search = params.search
      }
    }

    return axiosInstance.get("/moto-gear-categories", { params: apiParams })
  },

  // Create moto gear category (Admin only)
  createMotoGearCategory: (data: CreateMotoGearCategoryDto): Promise<MotoGearCategoryResponseDto> => {
    return axiosInstance.post("/moto-gear-categories", data)
  },

  // Update moto gear category (Admin only)
  updateMotoGearCategory: (id: string, data: UpdateMotoGearCategoryDto): Promise<MotoGearCategoryResponseDto> => {
    return axiosInstance.put(`/moto-gear-categories/${id}`, data)
  },

  // Delete moto gear category (Admin only)
  deleteMotoGearCategory: (id: string): Promise<DeleteMotoGearCategoryResponseDto> => {
    return axiosInstance.delete(`/moto-gear-categories/${id}`)
  },
}
